import axios from "axios";
import { useState } from "react";

function SuggestionForm({ handleClosePopUp, config }) {
  const [postLoading, setPostLoading] = useState(false);
  const [postSucess, setPostSucess] = useState(false);
  const [postError, setPostError] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    const formData = new FormData(e.target);
    const formDataObj = {};
    formData.forEach((value, key) => {
      formDataObj[key] = value;
    });
    setPostLoading(true);
    try {
      const response = await axios.post("/api/v1/suggestions/", formData, {
        headers: {
          "Content-Type": "application/json",
        },
        withCredentials: true,
        xsrfCookieName: "csrftoken",
        xsrfHeaderName: "X-CSRFToken",
      });
      setPostLoading(false);
      setPostSucess(true);
      setPostError(false);
      e.target.reset();
    } catch (error) {
      setPostLoading(false);
      setPostError(true);
    }
  };

  return (
    <div className="SuggestionForm">
      <div className="SuggestionForm-container">
        <div className="SuggestionForm-header">
          <button
            className="SuggestionForm-closeBtn"
            onClick={handleClosePopUp}
          >
            <i className="icon-cruz"></i>
          </button>
          <h3 className="SuggestionForm-title">
            {config.translations.suggestionFormTitle}
          </h3>
        </div>
        {!postSucess ? (
          <form className="SuggestionForm-form" onSubmit={handleSubmit}>
            <label className="SuggestionForm-label" htmlFor="title">
              {config.translations.suggestionFormLabelTitle}
              <input
                className="SuggestionForm-textInput"
                name="title"
                defaultValue=""
                type="text"
                id="title"
                required
                placeholder={config.translations.suggestionFormLabelTitlePH}
              />
            </label>
            <label className="SuggestionForm-label" htmlFor="description">
              {config.translations.suggestionFormLabelBody}
              <textarea
                className="SuggestionForm-areaInput"
                name="description"
                defaultValue=""
                id="description"
                placeholder={config.translations.suggestionFormLabelBodyPH}
                required
              ></textarea>
            </label>
            {postError && (
              <p className="SuggestionForm-error">
                {config.translations.suggestionFormError}
              </p>
            )}
            <div className="SuggestionForm-btnFooter">
              <button
                className={
                  postLoading
                    ? "SuggestionForm-submitBtn loading"
                    : "SuggestionForm-submitBtn"
                }
                type="submit"
                disabled={postLoading}
              >
                {config.translations.suggestionFormBtn}
              </button>
            </div>
          </form>
        ) : (
          <div className="SuggestionForm-sucess">
            <svg
              className="SuggestionForm-sucess-icon"
              xmlns="http://www.w3.org/2000/svg"
              height="48px"
              viewBox="0 -960 960 960"
              width="48px"
              fill="#e8eaed"
            >
              <path d="M480-80q-85 0-158-30.5T195-195q-54-54-84.5-127T80-480q0-84 30.5-157T195-764q54-54 127-85t158-31q75 0 140 24t117 66l-43 43q-44-35-98-54t-116-19q-145 0-242.5 97.5T140-480q0 145 97.5 242.5T480-140q145 0 242.5-97.5T820-480q0-30-4.5-58.5T802-594l46-46q16 37 24 77t8 83q0 85-31 158t-85 127q-54 54-127 84.5T480-80Zm-59-218L256-464l45-45 120 120 414-414 46 45-460 460Z" />
            </svg>
            <h4 className="SuggestionForm-sucess-msg">
              {config.translations.suggestionFormSucess}
            </h4>
            <button
              className="SuggestionForm-submitBtn"
              type="button"
              onClick={handleClosePopUp}
            >
              {config.translations.suggestionFormSucessBtn}
            </button>
          </div>
        )}
      </div>
    </div>
  );
}

export default SuggestionForm;